(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.braindateConstant = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.STATUS = void 0;

  var STATUS = {
    CONFIRMED: "confirmed",
    CANCELLED: "cancelled",
    PENDING: "pending",
    DECLINED: "declined"
  };
  _exports.STATUS = STATUS;
});